import {
  PHONE_REGISTRATION,
  ONE_TIME_PASSWORD,
  PHONE_HAS_REGISTRATION,
  PROMISE_PENDING,
  PROMISE_REJECTED,
  PROMISE_FULFILLED,
  BECOME_SELLER,
  AUTH_USER_KEY,
  AUTH_TOKEN_KEY,
  AUTH_SIGN_OUT,
  RESET_TOKEN_TOBE_SELLER,
  SENT_SMS,
  SENT_CALL
} from '../constants'

import error from '../utils/error'
import parseError from '../utils/error'

import {getRolesUtils, jwtPayloads} from '../utils'

const getTypeError = err => {
  switch(err.status_code){
    case 502 : {
      if(err.message == 'The phone number has been already registered')
      return "PHONE_NUMBER_ERR"
    };
    case 501 : {
      if(err.message === 'User entered the same mobile number')
      return "SAME_PHONE_NUMBER_ERR"
    };
    case 403 : {
      if((err.message === 'Request failed with status code 403') || (err.message === '403 Forbidden')) 
      return "UNVERIFIED_USER_ERR"
    };
    default: return "UNKNOWN_ERR"
  }
}

const initialState = {
  dataPhoneUser: {
    isFetch: false,
    error: null,
    status_code: null
  },
  dataVerify: {
    isFetch: false,
    error: null
  },
  isVerify: getRolesUtils(localStorage.getItem(AUTH_USER_KEY)).indexOf('seller') !== -1 ? true : false,
  isSubmitPhoneSale: getRolesUtils(localStorage.getItem(AUTH_USER_KEY)).indexOf('seller') !== -1 ? true : false,
  isSeller: getRolesUtils(localStorage.getItem(AUTH_USER_KEY)).indexOf('seller') !== -1 ? true : false,
  dataSms: {
    error: null,
    message: '',
    status_code: null
  },
  dataCitcall: {
    error: null,
    message: '',
    status_code: null
  }
}

const hasPhoneSubmit = (state, payload) => {
  let {status_code, message} = payload
  switch (status_code) {
    case 200: //user not register
      return {...state, dataPhoneUser: {...state.dataPhoneUser, isFetch: false, status_code, message, error: null}}
    case 201: //has been register but not input verify otp
      return {...state, dataPhoneUser: {...state.dataPhoneUser, data: payload.data, message, isFetch: false, status_code}, isSubmitPhoneSale: true}
    case 202: //
      return {...state, dataPhoneUser: {...state.dataPhoneUser, data: payload.data, message, isFetch: false, status_code}, isSubmitPhoneSale: true}
    case 203: // user must change number and render input number phone
      return {...state, dataPhoneUser: {isFetch: false, status_code, message, error: null}}
    default: return state
  }
}

const phoneSellerSubmit = (state, payload) => {
  let {data, message, status_code} = payload
  return {
    ...state,
    dataPhoneUser: {...state.dataPhoneUser, data, message, status_code, isFetch: false, error: null},
    isSubmitPhoneSale: true,
  }
}

const checkCodeOTP = (state, payload) => {
  let {data, message, status_code} = payload
  localStorage.setItem(AUTH_TOKEN_KEY, data.token)
  localStorage.setItem(AUTH_USER_KEY, jwtPayloads(data.token))
  return {
    ...state,
    dataVerify: {isFetch: false, data, message, status_code, error: null}
  }
}

const resetToken = (state, payload) => {
  let {data, message, status_code} = payload
  localStorage.setItem(AUTH_TOKEN_KEY, data.token)
  localStorage.setItem(AUTH_USER_KEY, jwtPayloads(data.token))
  return {
    ...state,
    dataVerify: {
      ...state.dataVerify,
      isFetch: false
    },
    isVerify: true
  }
}

const sentSmsMethod = (state, payload) => {
  let { error, message, status_code } = payload
  return {
    ...state,
    dataSms: {
      ...state.dataSms,
      error: null,
      message, 
      status_code
    },
  }
}

const OtpReducer = (state = initialState, actions) => {
  switch (actions.type) {
    case `${PHONE_HAS_REGISTRATION}${PROMISE_PENDING}`:
      return {...state, dataPhoneUser: {...state.dataPhoneUser, isFetch: true}}
    case `${PHONE_HAS_REGISTRATION}${PROMISE_FULFILLED}`:
      return hasPhoneSubmit(state, actions.payload)
    case `${PHONE_HAS_REGISTRATION}${PROMISE_REJECTED}`:
      return {...state, dataPhoneUser: {isFetch: false, ...error(actions.payload)}}
    case `${PHONE_REGISTRATION}${PROMISE_PENDING}`:
      return {...state, dataPhoneUser: {...state.dataPhoneUser, isFetch: true}}
    case `${PHONE_REGISTRATION}${PROMISE_FULFILLED}`:
      return phoneSellerSubmit(state, actions.payload)
    case `${PHONE_REGISTRATION}${PROMISE_REJECTED}`:
      const { error } = parseError(actions.payload)
      return {
        ...state, 
        dataPhoneUser: {
          ...state.dataPhoneUser, 
          isFetch: false, 
          error: {
            ...error, 
            type: getTypeError(error)}, 
            status_code: error.status_code
          }
        }
    case `${ONE_TIME_PASSWORD}${PROMISE_PENDING}`:
      return {...state, dataVerify: {...state.dataVerify, isFetch: true}}
    case `${ONE_TIME_PASSWORD}${PROMISE_FULFILLED}`:
      return checkCodeOTP(state, actions.payload)
    case `${ONE_TIME_PASSWORD}${PROMISE_REJECTED}`:
      return {...state, dataVerify: {isFetch: false, ...error(actions.payload)}}
    case `${BECOME_SELLER}`:
      return {...state, isSeller: true}
    case `${RESET_TOKEN_TOBE_SELLER}${PROMISE_PENDING}`:
    return {...state, dataVerify: {...state.dataVerify, isFetch: true}}
    case `${RESET_TOKEN_TOBE_SELLER}${PROMISE_FULFILLED}`:
      return resetToken(state, actions.payload)
    case `${RESET_TOKEN_TOBE_SELLER}${PROMISE_REJECTED}`: return state
    case `${AUTH_SIGN_OUT}`:
      return {...initialState}
    default: return state

  }
}

const smsSent = (state, actions) => {
  switch (actions.type) {
    case `${SENT_SMS}${PROMISE_PENDING}`:
      return {
        ...state,
        dataSms: {
          ...state.dataSms
        }
      }
    case `${SENT_SMS}${PROMISE_FULFILLED}`:
      return sentSmsMethod(state, actions.payload)
    case `${SENT_SMS}${PROMISE_REJECTED}`:
      return {
        ...state,
        dataSms: {
          ...state.dataSms,
          ...error(actions.payload)
        }
      }
    default: return state
  }
}

export default OtpReducer